module.exports = __webpack_public_path__ + "img/spain-external-causes-female.847ad1f3.png";